//import { rejects } from "assert";

class Webservice {
    url: string = "../Ashx/DashBoard.ashx";
    testUID:string|null = null
    constructor() {
        if (process.env.NODE_ENV == "development") {
            
            this.url = "http://localhost:56400/Ashx/DashBoard.ashx";

            //this.url = "http://localhost:56400/Ashx/Performance.ashx";
            //this.testUID = "L221212959"
            //this.testUID = "E222600814"
            //this.testUID = "A223990877"
            //this.testUID = "A128115827"
            //this.testUID = "F123784158"

            this.testUID = "A220747016"
            /*            
                新契約補全  
                A122162813   A128115827 A223990877
            */
        }
        console.log("init webservice ", this.url)
    }

    //最上層的menu選單
    asyncMenuChecker = async (): Promise<object> => {
        return await this.menuChecker()
    }

    menuChecker =():object=>{
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'MenuChecker')
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    asyncPageContent = async (GID:string): Promise<object> => {
        return await this.pageContent(GID)
    }
    
    //點選menu選單取回的內容
    pageContent =(GID:string):object=>{
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'PageContent')
            formData.append("GID", GID)
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    //取得部門單位ID
    asyncGetDeptNO= async (): Promise<object> => {
        return await this.getDeptNO()
    }

    getDeptNO = ():object=>{
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'GetDeptNoList')
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    //執行SP的內容
    asyncMenuContentReader = async (SP:string, Para:string): Promise<object> => {
        return await this.menuContentReader(SP, Para)
    }
    
    //點選menu選單取回的內容
    menuContentReader =(SP:string, Para:string):object=>{
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'Content_Reader')
            formData.append("N", SP)
            formData.append("V", Para)
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    //執行SP的內容
    asyncManagerReader = async (SP:string, GID:string, deptNo:string): Promise<object> => {
        console.log("asyncManagerReader", SP, GID, deptNo)
        return await this.managerReader(SP, GID, deptNo)
    }
    
    //點選menu選單取回的內容
    managerReader =(SP:string, GID:string, deptNo:string):object=>{
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'Manager_Reader')
            formData.append("N", SP)
            formData.append("GID", GID)
            formData.append("DeptNo", deptNo)
            console.log(SP, GID, deptNo)
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }
    //檔案上傳
    
    asyncPerformance = async (resType:string, year?:number): Promise<object> => {
        return await this.getPerformance(resType, year?year:0)
    }

    getPerformance = (resType:string, year:number): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", resType)
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }

            if(year>0){
                formData.append("QueryYear", year.toString())
            }
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    asyncGetNotice = async (type:string, N2?:string): Promise<object> => {
        return await this.getNotice(type, N2)
    }

    getNotice = (type:string, N2?:string): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'GetTypeContent')
            formData.append("type", type)
            if(this.testUID){
                formData.append("TestUID", this.testUID)
            }
            if(N2){
                formData.append("N2", N2)
            }          
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }

    asyncGetFile = async (filename:string): Promise<object> => {
        return await this.getFile(filename)
    }

    getFile = (filename:string): object => {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append("RequestType", 'GetFile')
            formData.append("FileName", filename)
            
            fetch(this.url, {
                method: 'POST',
                body: formData,
            }).then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    console.log("Performance 連線失敗，請聯絡資訊部");
                    return null;
                }
            }).then(result => {
                resolve(result);
            })
        })
    }
}


export default Webservice